import styled from 'styled-components';
import { AddLink as MaterialAddLink } from '../../../../../styles/icons';

export const Container = styled.div`
  width: 100%;
  height: 100%;
`;

export const AddLink = styled(MaterialAddLink)`
  width: 25px;
  height: 25px;
  fill: var(--secondary);
`;
